import { useEffect, useRef } from "react"
import { useRecoilState } from "recoil"
import { useVideoPopup } from "src/components/mediaPanel/floating-container/useVideoPopup"
import { recentUploadAttachmentUrlAtom } from "src/recoil/atoms/chats"
import { useWatchPartyController } from "../useWatchParty"

export const useHandleAttachmentUpload = () => {
  const [uploadedAttachmentUrl, setUploadedAttachmentUrl] = useRecoilState(
    recentUploadAttachmentUrlAtom
  )
  const shouldStartWatchParty = useRef(false)

  const { startWatchParty } = useWatchPartyController()
  const { toggleVideoPopup } = useVideoPopup()

  // This useEffect listen the successfully added attachment
  useEffect(() => {
    if (uploadedAttachmentUrl && shouldStartWatchParty.current) {
      startWatchParty(uploadedAttachmentUrl)
      toggleVideoPopup(true) // Display avatar in popup
    }
    shouldStartWatchParty.current = false
    setUploadedAttachmentUrl(null)
  }, [uploadedAttachmentUrl])

  const triggerWatchPartyOnUpload = () => {
    setUploadedAttachmentUrl(null)
    shouldStartWatchParty.current = true
  }

  return {
    triggerWatchPartyOnUpload
  }
}
